<template>
  <div class="materiel-affectations">
    <div class="row mb-3">
      <div class="col-12">
        <h6>Affectation du matériel</h6>
        <p class="text-muted">
          Affecter le matériel à un collaborateur (si applicable)
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <select-collaborateur
          v-model.number="localMateriel.materiel_collab_id"
          :text="'Affecter à un collaborateur'"
          @input="updateMateriel"
        ></select-collaborateur>
      </div>
    </div>
  </div>
</template>

<script>
import SelectCollaborateur from "@/components/bases/SelectCollaborateur.vue";

export default {
  components: {
    SelectCollaborateur
  },
  props: {
    materiel: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      internalMateriel: {}
    };
  },
  computed: {
    localMateriel: {
      get() {
        return Object.keys(this.internalMateriel).length > 0
          ? this.internalMateriel
          : this.materiel;
      },
      set(value) {
        this.internalMateriel = { ...value };
        this.updateMateriel();
      }
    }
  },
  watch: {
    materiel: {
      handler(newVal) {
        this.internalMateriel = { ...newVal };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateMateriel() {
      this.$emit("update", this.internalMateriel);
    },
    getCollaborateurName(id) {
      if (!id || !this.data.users) return "Non affecté";
      const user = this.data.users.find(u => u.id === id);
      return user
        ? `${user.collaborateur_nom} ${user.collaborateur_prenom}`
        : "Non affecté";
    }
  }
};
</script>

<style scoped>
.materiel-affectations {
  padding: 20px;
}
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
h6 {
  color: #333;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 0.5rem;
}
.table th {
  font-size: 0.875rem;
  font-weight: 600;
  background-color: #f8f9fa;
}
.table td {
  font-size: 0.875rem;
}
</style>
